import type { Ref } from 'react';
import {
  type InteractiveAtomSize,
  fromInteractiveAtomToIconSize,
} from '../utils/InteractiveAtomProps';

export type CheckboxValue = boolean | 'indeterminate';
export type CheckboxState = 'checked' | 'unchecked' | 'indeterminate';
export type CheckboxSize = InteractiveAtomSize;

export type CheckboxProps = {
  value: CheckboxValue;
  size?: CheckboxSize;
  onChange?: (value: boolean) => void;
  className?: string;
  disabled?: boolean;
  hasError?: boolean;
  innerRef?: Ref<HTMLButtonElement | HTMLDivElement>;
};

export function fromValueToState(value: CheckboxValue): CheckboxState {
  if (value === 'indeterminate') {
    return value;
  }
  return value ? 'checked' : 'unchecked';
}

export const fromCheckboxToIconSize = fromInteractiveAtomToIconSize;
